module.exports = __webpack_public_path__ + "static/media/audio-technica-ath-m40x.12d6a55c.jpg";